import { createApiDescription } from "../../helperFunctions";

export const recycleBinInfo = {
    deleteRecycleBin: createApiDescription(
        "This API can be called to delete the recycle bin signature.",
        [
            "API is used to delete signature if present in recycle-bin signature report page.",
            "API supports Callback mechanism, callbackUri can be configured in the request body with callback-api-key in the request header. Once request is sent from Delete recycle-bin organizer API, the response will be posted to the configured callback endpoint URL."
        ]
    ),
    recycleBin: createApiDescription(
        "This API can be called to get the list of recycle bin signatures with various filters applied in the request.",
        [
            "API provides results based on given filters of the request parameters and if no filter values are given, it provides results based on default values mapped with all filters.",
            "The default number of returns in the response will be 10."
        ]
    ),
    restoreRecycleBin: createApiDescription(
        "This API can be called to move the Recycle Bin Signature back to the delivered or archived signature.",
        [
            "Restore Recycle Bin API will be used to move signature to the Delivered or Archived if only present in Recycle Bin signature report page or in deleted status.",
            "Restore Recycle Bin API supports Callback mechanism, callbackUri can be configured in the request body with callback-api-key in the request header. Once request is sent, the response will be posted to the configured callback endpoint URL."
        ]
    ),
}